import React from 'react';
import SearchStocks from '../search-stocks';
import './detail-page-header.m.css';

const DetailPageHeader = ({ widget }) => {
  return (
    <div styleName="detail-header-container">
      <div styleName="search-box">
        <SearchStocks widget={widget} />
      </div>
    </div>
  );
};

export default DetailPageHeader;
